import { Button, Typography } from "@mui/material";
import React, { ReactElement } from "react";
import { useNavigate } from "react-router-dom";

import Modal from "../components/modal/modal";
import { Layout, LayoutRenderingProgress } from "../generated/gql/graphql";
import Routes from "../types/enums/routes";

type Props = {
  headline: string;
  open: boolean;
  layout: Pick<Layout, "id" | "renderingProgress" | "readOnly">;
  onClose(): void;
  onDuplicate(): void;
};

export default function LayoutActionsModal(props: Props): ReactElement {
  const { headline, open, layout, onClose, onDuplicate } = props;

  const navigate = useNavigate();

  function handleEditAction(): void {
    navigate(`${Routes.EDITOR}/${layout.id}`);
    onClose();
  }

  function handleDuplicateAction(): void {
    onDuplicate();
    onClose();
  }

  const { renderingProgress, readOnly } = layout;
  const canEditLayout =
    renderingProgress !== LayoutRenderingProgress.InProgress &&
    renderingProgress !== LayoutRenderingProgress.Generated &&
    renderingProgress !== LayoutRenderingProgress.PreviewInProgress;

  return (
    <Modal
      open={open}
      headline={headline}
      onClose={() => onClose()}
      className="h-fit max-w-xl"
    >
      <Typography className="text-[#4A4A4A] text-[20px] font-bold">
        {canEditLayout
          ? readOnly
            ? "This layout is not part of your workspace. " +
              "Please duplicate it to one of your workspace`s projects, " +
              "so that you can start using this layout as a template."
            : "Do you want to edit this Layout or create a duplicate?"
          : renderingProgress === LayoutRenderingProgress.InProgress ||
              renderingProgress === LayoutRenderingProgress.PreviewInProgress
            ? "This layout is currently being generated, please wait. If you want to re-use this layout you can duplicate it with the button below."
            : "This layout has already been completed and is locked for editing. Please duplicate it, to reuse this layout."}
      </Typography>
      <div className="">
        {canEditLayout && !readOnly && (
          <div className="flex justify-between py-[36px] items-center border-b border-t border-1 border-[#cbd5e1] mt-[36px] mx-[-36px] px-[36px]">
            <span className="text-[20px] text-[#4A4A4A]">Start a new copy</span>
            <Button
              variant="outlined"
              className="text-[#DD2127] text-[18px] py-[8px] !border-[#DD2127] !rounded-xl w-[160px] text-center px-[5px]"
              onClick={() => handleDuplicateAction()}
            >
              Save as new
            </Button>
          </div>
        )}
        <div className="flex justify-between py-[36px] pb-0 items-center mx-[-36px] px-[36px]">
          <span className="text-[20px] text-[#4A4A4A]">
            Keep working on this version
          </span>
          <Button
            variant="outlined"
            className="text-white text-[18px] py-[8px] !border-[#DD2127] bg-[#DD2127] !rounded-xl w-[160px] text-center px-[5px]"
            onClick={() => handleEditAction()}
          >
            Keep Editing
          </Button>
        </div>
      </div>
    </Modal>
  );
}
